import { Box } from "@mui/material"
import { CalendarioTemplate } from "../../../Templates/CalendarioTemplate"
import { Card } from "../components/Card"

export const Infantil = () => {
  return (
    <Box sx={{ width: "85vw", maxWidth: "100vw" }}>
      <CalendarioTemplate
        title="Pré - quinto ano"
        subtitle="Saiba as datas das provas e trabalhos de suas disciplinas!"
      >
        <Card
          title="Matemática"
          tags={[""]}
        />
        <Card
          title="Matemática"
          tags={[""]}
        />
        <Card
          title="Matemática"
          tags={[""]}
        />
        <Card
          title="Matemática"
          tags={[""]}
        />
        <Card
          title="Matemática"
          tags={[""]}
        />
        <Card
          title="Matemática"
          tags={[""]}
        />
      </CalendarioTemplate>
    </Box>
  )
}
